module.exports = __webpack_public_path__ + "img/login.51abf5f1.png";